function openDetail(evt, detailName) {
  // 全てのタブコンテンツを非表示にする
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // 全てのタブリンクを非アクティブにする
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }

  // クリックされたタブとタブコンテンツを表示する
  document.getElementById(detailName).style.display = "block";
  evt.currentTarget.className += " active";
}

// デフォルトで最初のタブを開く
document.getElementsByClassName("tablinks")[0].click();
